import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";

export const getPageHistoryState = (state: CustomApplicationState) => {
    return state?.cpeState?.PageHistory;
}